var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mockData as chatData } from '@web/lib/demo/data/chatEvents';
import { filterData, getUsers } from '@web/lib/demo/utils';
import { ChatEventActionEnum } from '@workalizer/shared';
import { groupBy, isChatSpaceRoomType } from '@workalizer/shared/utils';
import { differenceInDays, format } from 'date-fns';
var getDailyAvgPostedPerUser = function (data, dateFrom, dateTo, userCount) {
    if (userCount === 0) {
        return 0;
    }
    var daySpan = differenceInDays(dateTo, dateFrom) + 1;
    var days = daySpan > 0 ? daySpan : 1;
    var chatEventsAggregateDate = data.map(function (e) { return (__assign(__assign({}, e), { date: format(new Date(e.date), 'yyyy-MM-dd') })); });
    var groupByDate = groupBy(chatEventsAggregateDate, 'date');
    var avgMessagesPerDays = Object.values(groupByDate).map(function (messagesOnDay) { return messagesOnDay.length / userCount; });
    return Math.round(avgMessagesPerDays.reduce(function (acc, cur) { return acc + cur; }, 0) / days);
};
export var chatMessageActivity = function (input) {
    var users = getUsers({
        orgUnitId: input.orgUnitId,
        userId: input.userId
    });
    var chat = filterData(chatData, [
        {
            key: 'date',
            value: input.dateFrom,
            operator: 'gt'
        },
        {
            key: 'date',
            value: input.dateTo,
            operator: 'lt'
        },
        {
            key: 'action',
            value: ChatEventActionEnum.CHAT_MESSAGE_POSTED,
            operator: 'eq'
        },
        {
            key: 'userId',
            value: users.map(function (user) { return user.id; }),
            operator: 'in'
        }
    ]);
    var dailyAvgPostedPerUser = getDailyAvgPostedPerUser(chat, input.dateFrom, input.dateTo, users.length);
    var postedMessagesInSpaces = chat.filter(function (event) {
        return isChatSpaceRoomType(event.room.type);
    }).length;
    return {
        dailyAvgPostedPerUser: dailyAvgPostedPerUser,
        postedMessages: chat.length,
        postedMessagesInSpaces: postedMessagesInSpaces
    };
};
